export enum MAP_ADDRESS_TYPES {
  JOBSITE = 'jobsite',
  POINT_OF_DELIVERY = 'point_of_delivery',
  PLANT = 'plant',
}

/**
 * The types of physical address used on a map.
 */
export type MapAddressTypes = MAP_ADDRESS_TYPES.JOBSITE | MAP_ADDRESS_TYPES.POINT_OF_DELIVERY | MAP_ADDRESS_TYPES.PLANT;
